import cn from "classnames";
import { ReactElement } from "react";
import { Trans, useTranslation } from "react-i18next";

import { Button } from "oneclick-component/src/components/Button";
import { SearchInput } from "oneclick-component/src/components/inputs";
import { SearchIcon } from "oneclick-component/src/icon";
import { BriefStation } from "oneclick-component/src/store/apis/enhancedApi";
import { StationFilter } from "../../components/StationFilter";

interface ActionBarProps {
  className?: string;
  searchString?: string;
  onChangeSearchString: (value: string) => void;
  showStationFilter: boolean;
  stationFilter: number | null;
  onChangeStationFilter: (station: BriefStation | null) => void;
  isMobileSearchView: boolean;
  onEnterMobileSearchView: () => void;
}
const PaidMessageSentActionBar = (props: ActionBarProps): ReactElement => {
  const {
    className,
    searchString,
    onChangeSearchString,
    stationFilter,
    onChangeStationFilter,
    showStationFilter,
    isMobileSearchView,
    onEnterMobileSearchView,
  } = props;
  const { t } = useTranslation();

  return (
    <>
      {/* Mobile view */}
      {!isMobileSearchView ? (
        <div
          className={cn("flex", "sm:hidden", "items-end", "gap-x-6", className)}
        >
          <Button
            className={cn("!px-3", "!py-2.5")}
            theme="white"
            onClick={onEnterMobileSearchView}
          >
            <SearchIcon className={cn("w-5", "h-5", "fill-gray-400")} />
          </Button>
          <SearchInput
            initialSearchText={searchString}
            className={cn("flex-1", "min-w-0", "h-10.5")}
            onChange={onChangeSearchString}
          />
        </div>
      ) : (
        <div className={cn("flex", "flex-col", "gap-2", className)}>
          <div className={cn("flex", "gap-6")}>
            {showStationFilter ? (
              <div>
                <label
                  className={cn(
                    "text-sm",
                    "block",
                    "font-normal",
                    "text-left",
                    "text-black/86",
                    "mb-1"
                  )}
                >
                  <Trans i18nKey={"shiftList.filter.workingStation.label"} />
                </label>
                <StationFilter
                  className="w-30"
                  selectedStationId={stationFilter}
                  onStationSelected={onChangeStationFilter}
                />
              </div>
            ) : null}
          </div>
        </div>
      )}
      {/* Desktop view */}
      <div
        className={cn(
          "hidden",
          {
            "sm:flex": !isMobileSearchView,
          },
          "mt-0",
          "flex-wrap",
          "items-end",
          "gap-y-4",
          "gap-x-6",
          className
        )}
      >
        <div
          className={cn("flex", "gap-6", "pr-6", "border-r", "border-black/12")}
        >
          {showStationFilter ? (
            <div>
              <label
                className={cn(
                  "text-sm",
                  "block",
                  "font-normal",
                  "text-left",
                  "text-black/86",
                  "mb-1"
                )}
              >
                <Trans i18nKey={"shiftList.filter.workingStation.label"} />
              </label>
              <StationFilter
                className="w-30"
                selectedStationId={stationFilter}
                onStationSelected={onChangeStationFilter}
              />
            </div>
          ) : null}
        </div>
        <div className={cn("flex-1", "-mr-6")} />
        <SearchInput
          initialSearchText={searchString}
          className={cn("w-83", "h-10.5")}
          onChange={onChangeSearchString}
          placeholder={t("paidMessageSentList.filter.searchInput.placeholder")}
        />
      </div>
    </>
  );
};

export default PaidMessageSentActionBar;
